module.exports = __webpack_public_path__ + "img/dots.1a44bd5d.svg";